export const portalData = {
    // Fax Details
    hasFax: false,
    faxNo: "",
    
    // Whatsapp details
    hasWhatsApp: true,
    whatsAppNo: "+6018 312 0999",
    whatsAppNoHolderName: "theheritagekapas",
    hasAltWhatsApp: true,
    altWhatsAppNo: "+6017 917 0120",
    altWhatsAppNoHolderName: "Hweihoung",
    hasAltWhatsApp1: false,
    altWhatsAppNo1: "",
    altWhatsAppNoHolderName1: "",
    hasAltWhatsApp2: false,
    altWhatsAppNo2: "",
    altWhatsAppNoHolderName2: false,
    
    // Phone number details
    hasPhoneNo: true,
    phoneNo: "+6018 312 0999",
    hasAltPhoneNo: true,
    altPhoneNo: "+6017 917 0120",
    
    // Telephone number details
    hasTellNo: true,
    tellNo: "+6018 312 0999",
    tellNoHolderName: "theheritagekapas",
    hasAltTellNo: true,
    altTellNo: "+6017 917 0120",
    altTellNoHolderName: "Hweihoung",
    hasAltTellNo2: false,
    altTellNo2: "",
    altTellNoHolderName2: "",
    
    // Portal information details
    portalNameXSpace: "The Heritage Kapas",
    portalName: "The Heritage Kapas",
    portalFullName: "The Heritage Holidays Sdn. Bhd.",
    portalFullNameUppercase: "THE HERITAGE HOLIDAYS SDN. BHD.",
    portalShortAddress: "Lot 7075, Kampung Laut",
    portalAddress: "Lot 7075, Kampung Laut, 21080 KualaTerengganu",
    portalAddressFirstPart: "Lot 7075, Kampung Laut,",
    portalAddressSecondPart: "21080 KualaTerengganu",
    portalAddressDetails: "Lot 7075, Kampung Laut, Pengadang Buluh, 21080 KualaTerengganu, Terengganu",
    hasPortalRegNo: false,
    portalRegNo: "",
    
    // Portal Bank Details
    portalBankName: "Maybank",
    portalBankAddress: "",
    portalBankAccHolderName: "The Heritage Holidays Sdn. Bhd.",
    portalBankAccNo: "563011047455",
    hasPortalBankSwiftCode: true,
    portalBankSwiftCode: "MBBEMYKL",   
     
    portalEmail: "theheritagekapas@gmail.com",
    portalTermAndCondUrl: process.env.REACT_APP_PORTAL_TERM_AND_COND_URL,   
    appName: "Island Resort Centralised Reservation Platform",

    // GST details
    hasGst: false,
    gstNo: true,
     
    // Website
    portalWebsite: process.env.REACT_APP_PORTAL_WEBSITE,
   
    // Travoxis Website
    travoxisWebsite: process.env.REACT_APP_TRAVOXIS_WEBSITE,
   
    // Facebook page link
    facebookMessengerLink: "https://www.facebook.com",
   
    // portal S3 base url
    s3AwsUrl: "",
   
    adminPortalUrl: process.env.REACT_APP_ADMIN_PORTAL_URL,
  
    // Portal Jetty names
    jettyOne: "Marang Jetty",
    jettyTwo: "",
    jettyThree: "",
    jettyOneToTwoTime: "1:00 pm / 3:00pm",
    jettyTwoToOneTime: ""
}  